import React, { Component } from 'react';
import LoginAccountInput from "../LoginAccountInput";
import BsyBtn from "../BsyBtn";
import tipAlert from "../BsyAlertTip/Staticize";
import PubSub from "pubsub-js";
import ImgCodeInput from "../ImgCodeInput";
import EntryInputCode from "../EntryInputCode";
import './index.css'
import LoginPasswordLevel from "../LoginPasswordLevel";

class LoginUserActivation extends Component {
    state = {
        EntryInputCodeShow: false,
        mobile: window.activationInfo ? window.activationInfo.value : '', 
        mobileType: window.activationInfo ? window.activationInfo.code : '86',
        mode: window.activationInfo ? window.activationInfo.type : '',
        activationPasswordShow: true
    }
    constructor(props) {
        super(props);
        this.pubsub_token = PubSub.subscribe("levelPass", (topic, value) => {
            this.setState({
                passLevel: value.value
            })
        })
    }
    accountValue = (ref) => {
        this.account = ref
    }

    passwordValue = (ref) => {
        this.password = ref
    }
    imgCodeValue = (ref) => {
        this.imgCode = ref
    }
    codeLogin = () => {
        const code = this.imgCode.getValue();
        const accountValue = this.account.getValue();
        if (!this.state.passLevel) {
            tipAlert({
                type: "error",
                msg: React.language('set.password.tip')
            })
            return
        }
        const data = {
            "mode": "active_code",  //激活账号的验证码传 active_code 找回密码getpwd_mobile_code
            "data": {
                "mobile": this.state.mobile,
                "country_code": this.state.mobileType,  //地区编码
                "code": code.value //图形验证码
            }
        }
        React.axios('/user/signin', data).then(res => {
            if (res.data.code === 200) {
                tipAlert({
                    type: "success",
                    msg: res.data.msg
                })
                this.setState({
                    EntryInputCodeShow: true,
                    activationPasswordShow: false
                })
                PubSub.publish('codeCont', { value: accountValue });
            }else if(res.data.code===400){
                tipAlert({
                    type: "error",
                    msg : res.data.msg
                })
            }
        }).catch(res => {
            const res1 =  res.response ? res.response.data : res.data;
            this.imgCode.changeCode()
            if (res1.toString().indexOf('"Message":"OK"') === -1) {
                if (res1.toString().indexOf('code')) {
                    // tipAlert({
                    //     type: "error",
                    //     msg: res1.msg
                    // })
                }
                else {
                    // tipAlert({
                    //     type: "error",
                    //     msg: React.language("System.error")
                    // })
                }
            } else {
                tipAlert({
                    type: "success",
                    msg: res1.msg
                })
                this.setState({
                    EntryInputCodeShow: true,
                    activationPasswordShow: false
                })
                PubSub.publish('codeCont', { value: accountValue });
            }
        })
    }
    LoginCode = (values, state, cd) => {
        const { value, countryCode } = state
        if (!this.state.passLevel) {
            tipAlert({
                type: "error",
                msg: React.language('set.password.tip')
            })
            cd && cd(!0, React.language('set.password.tip'));
            return
        }
        this.timer1 = setTimeout(() => {
            const data = {
                "mode": "active",
                "data": {
                    "mobile": value,
                    "pwd": this.state.password,
                    "country_code": countryCode,  //地区编码
                    "code": values  //手机验证码
                }
            }
            React.axios('/user/signin', data).then(res => {
                if (res.data.code === 200) {
                    tipAlert({
                        type: "success",
                        msg: res.data.msg
                    })
                    window.location.href = res.data.redirectTo
                }else if(res.data.code===400){
                    tipAlert({
                        type: "error",
                        msg : res.data.msg
                    })
                }
            }).catch(res => {
                const res1 =  res.response ? res.response.data : res.data;
                this.imgCode.changeCode()
                if (res1.toString().indexOf('"Message":"OK"') === -1) {
                    if (res1.toString().indexOf('code')) {
                        // tipAlert({
                        //     type: "error",
                        //     msg: res1.msg
                        // })
                        cd && cd(!0, res1.msg);
                    }
                    else {
                        // tipAlert({
                        //     type: "error",
                        //     msg: React.language("System.error")
                        // })
                        cd && cd(!0, React.language("System.error"));
                    }
                } else {
                    tipAlert({
                        type: "success",
                        msg: res1.msg
                    })
                    window.location.href = res1.redirectTo
                }
            })
        }, 300)
    }

    componentDidMount() {
        const el = document.getElementsByClassName("LoginUserActivation")[0];
        if (el) {
            el.addEventListener("keyup", (event) => {
                if (event.keyCode === 13) {
                    this.codeLogin()
                }
            })
        }
    }

    changeValue = (event) => {
        const val = event.target.value
        if (val !== '') {
            this.setState({ showClear: true, showPassword: true, showPasswordCont: true })
        } else {
            this.setState({ showClear: false, showPassword: false })
        }
        this.setState({ password: val })
        PubSub.publish('levelValue', { value: val });
    }

    clearInputValue = (event) => {
        event.target.previousSibling.value = "";
        event.target.parentNode.classList.remove('phone')
        this.setState({ showClear: false, showPassword: false })
    }
    changePasswordType = () => {
        this.setState({
            showPasswordType: !this.state.showPasswordType
        })
    }


    render() {
        const { EntryInputCodeShow, activationPasswordShow, mobile, mobileType, showClear, showPasswordType, showPassword, showPasswordCont, password,mode } = this.state
        return (
            <div className="LoginUserActivation">
                {activationPasswordShow && <div className="activationPassword">
                    <div className="title">
                        {React.language('user.activation')}
                    </div>
                    <LoginAccountInput value={this.account ? this.account.getValue().value : mobile} mode={mode} mobileType={mobileType} isreadonly={true} getValue={this.accountValue} />
                    <div className="setPasswordInput">
                        <input onBlur={() => {
                            this.setState({
                                showPasswordCont: false
                            })
                        }} onChange={this.changeValue} type={showPasswordType ? "text" : "password"} placeholder={React.language('password.set.warning')} />
                        {showClear && <i onClick={this.clearInputValue} className="icon-dingding-guide-close" />}
                        {showPassword && <i onClick={this.changePasswordType} className={showPasswordType ? "changePasswordType icon-bsy-filter-show" : "changePasswordType icon-bsy-filter-hide"} />}
                        {showPasswordCont && <LoginPasswordLevel getIsPass={this.passwordValue} password={password} />}
                    </div>
                    <ImgCodeInput getValue={this.imgCodeValue} />
                    <BsyBtn onClick={this.codeLogin} text={React.language('m.code.send')} />
                </div>}
                {EntryInputCodeShow && <EntryInputCode mode="active" LoginCode={this.LoginCode} />}
            </div>
        );
    }
}

export default LoginUserActivation;